import { ExportExclusionsPanelWebComponent } from './component/ExportExclusionsPanelWebComponent';
import { WEB_COMPONENT_EXPORT_EXCLUSIONS_PANEL } from '../../webcomponents.constants';

/**
 * The export exclusions window component
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExportExclusionsPanelWebComponent };

window.customElements.define(WEB_COMPONENT_EXPORT_EXCLUSIONS_PANEL, ExportExclusionsPanelWebComponent);
